export const ADD_QUESTIONS_REQUEST = 'ADD_QUESTIONS_REQUEST'
export const ADD_QUESTIONS_SUCCESS = 'ADD_QUESTIONS_SUCCESS'
export const ADD_QUESTIONS_FAILURE = 'ADD_QUESTIONS_FAILURE'
export const ADD_QUESTIONS_UPDATE = 'ADD_QUESTIONS_UPDATE'

